<template>
  <div>
    <v-row align="center" class="pa-4 mb-2">
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="ml-2"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
        </template>
        <v-list width="300" dense>
          <v-list-item
            v-if="$checkPermission('update_car_number_barrier')"
            @click.prevent="popupExport = true"
          >
            <v-list-item-title>Загрузить номера ИЗ устройства</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="$checkPermission('update_car_number_barrier')"
            @click.prevent="popupImport = true"
          >
            <v-list-item-title>Загрузить номера В устройство</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Модальное окно для экспорта данных из устройства -->
      <v-dialog v-model="popupExport" max-width="500" content-class="dialog-border-radius">
        <v-card>
          <v-card-title>Загрузка номеров из устройства</v-card-title>
          <v-card-text>
            Эта операция загрузит номера из устройства в базу данных ЛК домофонии.
            Устройство автоматически обрабатывает возможные дубли, поэтому
            дополнительных действий с вашей стороны не требуется.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="popupExport = false">Отмена</v-btn>
            <v-btn color="primary" @click="handleExport()">Подтвердить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Модальное окно для импорта данных в устройство -->
      <v-dialog v-model="popupImport" max-width="500" content-class="dialog-border-radius">
        <v-card>
          <v-card-title>Загрузка номеров в устройство</v-card-title>
          <v-card-text>
            Внимание! Это действие удалит все текущие записи на устройстве и загрузит номера из базы данных.
            Убедитесь, что это действительно необходимо.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="popupImport = false">Отмена</v-btn>
            <v-btn color="primary" @click="handleImport()">Подтвердить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showInvalidNumbersModal" max-width="500" content-class="dialog-border-radius">
        <v-card>
          <v-card-title>Загрузка номеров в базу данных</v-card-title>
          <v-card-text>
            Внимание! Эти номера не попали в базу данных, проверьте их запись.
            <div v-if="invalidCarNumbers">{{ invalidCarNumbers.join(', ') }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showInvalidNumbersModal = false">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-title>Госномера автомобилей для распознавания</v-card-title>
      <div>
        <BaseTextField
          v-model="carSearch"
          type-input="string"
          :is-button="false"
          :allow-only-latin="true"
          label="Номер автомобиля"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="CreationStateNumber"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-new-box</v-icon>
          </v-btn>
        </template>
        <span>Создание госномера</span>
      </v-tooltip>
      <v-dialog v-model="dialogNew" max-width="650" content-class="dialog-border-radius">
        <new-car-number-dialog
          :active.sync="dialogNew"
          icon="mdi-car"
          :barrier="barrier"
          message="Новый номер автомобиля"
          @save="updateTableNumber"
          @close="dialogNew = false"
        />
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="popupImportDB = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-application-import</v-icon>
          </v-btn>
        </template>
        <span>Импорт госномеров</span>
      </v-tooltip>
      <v-dialog v-model="popupImportDB" max-width="500" content-class="dialog-border-radius">
        <v-card>
          <v-card class="card-header" style="box-shadow: none;">
            <span class="text-h5">Импорт базы госномеров</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  right
                  class="btn__icon pa-0"
                  style="position: absolute; right: 15px; height: 50%"
                  width="18"
                  @click="closePopupDeleteKeys"
                >
                  <v-icon color="white">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Закрыть</span>
            </v-tooltip>
          </v-card>
          <v-card-text class="pa-4">
            <strong class="black--text">
              Этот импорт происходит исключительно в базу данных ЛК домофонии. Данные не отправляются на устройство.
            </strong>
          </v-card-text>
          <v-col cols="11" class="py-0 mt-4">
            <v-file-input
              v-model="importFile"
              accept=".csv"
              outlined
              dense
              flat
              label="Файл с номерами автомобилей"
              :rules="[
                value => !!value || 'Обязательное поле',
              ]"
              append-icon="mdi-information-outline"
              @click:append="infoImportUpload = !infoImportUpload"
            ></v-file-input>
            <v-col
              v-if="infoImportUpload"
              class="ml-5 pt-0"
            >
              <p>Формат файла: csv</p>
              <p>Кодировка файла должна быть: Юникод (UTF-8)</p>
            </v-col>
          </v-col>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn
                large
                color="success"
                class="text-none"
                dense
                :disabled="importFile === null"
                @click.prevent="importListCarNumbers()"
              >
                Импортировать
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="downloadListCarNumbers"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
          </v-btn>
        </template>
        <span>Скачать отчёт</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#B81B1B"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="massRemovalNumbers"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-delete-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>Удалить номера</span>
      </v-tooltip>
      <v-dialog v-model="showDeleteCarsDialog" max-width="400" content-class="dialog-border-radius">
        <baseDeleteModal
          :active.sync="showDeleteCarsDialog"
          @close="showDeleteCarsDialog = false"
          @submit="deleteCarNumberSelect('remove', false)"
          messageTitle="Удалить номера автомобилей?"
          messageText="Подтверждая, вы удалите госномер из базы шлагбаума.
          Если номера привязаны к абоненту, они будут отвязаны."
        />
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="updateListCars"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="headersTable"
      :items="filtered"
      item-key="id"
      show-select
      v-model="selectedCarNumbers"
      :footer-props="{ showFirstLastPage: true }"
      @input="handleSelectionChange"
    >
      <template v-slot:header.data-table-select>
        <div></div>
      </template>
      <template v-slot:item.guest="{ item }">
        <div v-if="item.guest_entry_start && item.guest_entry_end">
          {{ ruDateFormat(item.guest_entry_start, true) }} - {{ ruDateFormat(item.guest_entry_end, true) }}
        </div>
        <div v-else-if="!item.guest_entry_start && item.guest_entry_end">
          Ошибка - {{ ruDateFormat(item.guest_entry_end, true) }}
        </div>
        <div v-else-if="item.guest_entry_start && !item.guest_entry_end">
          {{ ruDateFormat(item.guest_entry_start, true) }} - Ошибка
        </div>
      </template>
      <template v-slot:item.created_at="{ item }">
        <div v-if="item.created_at">
          {{ ruDateFormat(item.created_at) }}
        </div>
      </template>
      <template v-slot:item.notification="{ item }">
        <div v-if="item.notification === 'on'" style="color: #388E3C">Включены</div>
        <div v-else  style="color: crimson">Выключены</div>
      </template>
      <template v-slot:item.status="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="primary darken-1"
              text
            >
              <v-icon small :color="item.is_blocked ? 'orange' : 'green'">
                mdi-checkbox-blank-circle
              </v-icon>
            </v-btn>
          </template>
          <span v-if="item.is_blocked">Заблокирован</span>
          <span v-else>Активен</span>
        </v-tooltip>
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="$checkPermission('update_car_number_barrier')"
                icon
                text
                tile
                small
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                disabled
                height="18"
                @click.stop="$set(dialogEdit, item.id, true)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <template v-if="$checkPermission('update_car_number_barrier')">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  v-bind="attrs"
                  v-on="on"
                  tile
                  small
                  class="btn__icon ml-4 mr-1"
                  width="18"
                  height="18"
                  @click.stop="$set(dialogWarning, item.id, true)"
                >
                  <v-icon size="large">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
            <v-dialog v-model="dialogWarning[item.id]" max-width="400" content-class="dialog-border-radius">
              <baseDeleteModal
                :active.sync="dialogWarning[item.id]"
                @close="$set(dialogWarning, item.id, false)"
                @submit="deleteCarNumber('remove', item.car_number, false)"
                messageTitle="Удалить номер автомобиля?"
                messageText="Подтверждая, вы удалите госномер из базы. Если номер привязан к абоненту, он будет отвязан."
              />
            </v-dialog>
          </template>
        </v-row>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogNoticeResComplex" max-width="500" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          Внимание
        </v-card-title>
        <v-card-text>
          <p>
            Этот шлагбаум связан с жилым комплексом. Вы можете перейти в раздел управления
            <b>{{ getResidentialComplexName(barrier.residential_complex_id) }}</b>
            , чтобы работать с шлагбаумами ЖК. Или же вы можете продолжить работать с этим шлагбаумом здесь.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            class="text-none"
            outlined
            dark
            right
            rounded
            :to="`/residential-complexes/${barrier.residential_complex_id}/view`"
          >
            Перейти в Жилой комплекс
          </v-btn>
        <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="text-none"
            outlined
            dark
            right
            rounded
            @click.prevent="continueHere()"
          >
            Продолжить здесь
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="resultDialog" max-width="700" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          Результат импорта данных в устройство
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(result, index) in results" :key="index">
              <v-list-item-content>
                <v-list-item-subtitle :class="result.success ? 'text-success' : 'text-error'">
                  {{ result.success ? 'Успешно' : 'Ошибка.' }}
                  <span style="color: orange" v-if="result.error">{{ result.error }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <div>
              <p style="color: green">Остальные гос номера были загружены на устройство</p>
            </div>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="resultDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import BaseTextField from '../../../BaseTextField';
import baseDeleteModal from '../../../BaseDeleteModal';
import NewCarNumberDialog from '../components/NewCarNumberDialog';

export default {
  name: 'ListAbonents',
  props: {
    barrier: {
      type: Object,
    },
    resComplexName: Array,
    responseCars: Array,
  },
  mixins: [ruDateFormatMixin],
  components: { NewCarNumberDialog, BaseTextField, baseDeleteModal },
  data () {
    return {
      isCreated: true,
      lastCopiedText: null,
      filters: {},
      filterAbonents: {},
      telephoneSearch: '',
      carSearch: '',
      startDate: '',
      endDate: '',
      importFile: null,
      dialogWarning: {},
      dialogNew: false,
      results: [],
      resultDialog: false,
      popupImport: false,
      infoImportUpload: false,
      popupImportDB: false,
      selectedCarNumbers: [],
      invalidCarNumbers: [],
      showDeleteCarsDialog: false,
      popupExport: false,
      dialogNoticeResComplex: false,
      showInvalidNumbersModal: false,
      dialogEdit: {},
      totalAccounts: 0,
      headersTable: [
        { text: 'id', value: 'id', align: 'center' },
        { text: 'Номер автомобиля', value: 'car_number', sortable: false, align: 'center' },
        { text: 'Уведомления', value: 'notification', sortable: false, align: 'center' },
        { text: 'Промежуток действия номера', value: 'guest', sortable: false, align: 'center', width: '25%' },
        { text: 'Статус', value: 'status', sortable: false, align: 'center', width: '5%' },
        { text: 'Дата и время создания', value: 'created_at', sortable: false, align: 'center', width: '25%' },
        { text: '', value: 'action', sortable: false, align: 'center', width: '7%' },
      ],
    };
  },
  created () {
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    filtered () {
      if (this.carSearch) {
        return this.responseCars.filter(item => {
          return item.car_number !== null &&
            String(item.car_number).toLowerCase().includes(this.carSearch.toLowerCase());
        });
      } else {
        return this.responseCars;
      }
    },
  },
  methods: {
    ...mapActions({
      simpleUpdateAbonent: 'Abonents/simpleUpdateAbonent',
      loadAbonents: 'Abonents/loadAbonents',
      updateCarNumber: 'Barriers/updateCarNumber',
      downloadListCarsNumbers: 'Barriers/downloadListCarsNumbers',
      importCarNumbersByCsv: 'Barriers/importCarNumbersByCsv',
      getBarrier: 'Barriers/getBarrier',
    }),
    async getData () {
      this.getBarrier({
        id: this.$route.params.id,
        includes: ['car_numbers'],
      })
        .then(() => {
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке информации');
        });
    },
    massRemovalNumbers () {
      if (this.selectedCarNumbers.length) {
        this.showDeleteCarsDialog = true;
      } else {
        this.$flash_danger('Выберите номер авто.');
      }
    },
    handleSelectionChange () {
      if (this.selectedCarNumbers.length > 5) {
        this.selectedCarNumbers.pop();
        this.$flash_danger('Вы можете выбрать не более 5 элементов.');
      }
    },
    async deleteCarNumberSelect (actionShould, notification) {
      const data = this.selectedCarNumbers.map(item => item.car_number);

      for (const carNumber of data) {
        await this.getAbonentData(carNumber);

        this.action = 'Удаление госномера';
        const date = [];
        await this.updateTableNumber(actionShould, carNumber, notification, date, true);
      }
      await this.getData();
      this.selectedCarNumbers = [];
    },
    handleExport () {
      this.popupExport = false;
      this.action = 'Экспорт';
      this.updateTableNumber('export');
    },
    handleImport () {
      this.popupImport = false;
      this.action = 'Импорт';
      this.updateTableNumber('import');
    },
    CreationStateNumber () {
      if (this.barrier.residential_complex_id) {
        this.dialogNoticeResComplex = true;
        return;
      }
      this.dialogNew = true;
    },
    continueHere () {
      this.dialogNoticeResComplex = false;
      this.dialogNew = true;
    },
    getResidentialComplexName (id) {
      const complex = this.resComplexName.find(item => item.id === id);
      return complex ? complex.name : '';
    },
    downloadListCarNumbers () {
      this.downloadListCarsNumbers({
        id: this.$route.params.id,
      })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'cars-numbers.csv';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$flash_warning('Не удалось скачать отчёт');
        });
    },
    importListCarNumbers () {
      const formData = new FormData();
      formData.append('csv_file', this.importFile);
      this.popupImportDB = false;
      this.importCarNumbersByCsv({
        id: this.$route.params.id,
        formData,
        actionShould: 'import_bd',
      })
        .then(async (response) => {
          if (response.data.invalid_car_numbers && response.data.invalid_car_numbers.length > 0) {
            this.invalidCarNumbers = response.data.invalid_car_numbers;
            this.showInvalidNumbersModal = true;
          }
          await this.closePopupDeleteKeys();
          this.$flash_success('Дейсвие успешно сохранено!');
          await this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при импорте данных в базу данных.');
        });
    },
    async updateListCars () {
      await this.getData()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    async getAbonentData (carNumber) {
      this.filterAbonents.car_number = carNumber;
      try {
        const data = await this.loadAbonents({
          filters: this.filterAbonents,
        });

        if (data.abonents[0]) {
          const dataManagement = {
            car_number: '',
          };
          await this.simpleUpdateAbonent({
            idAbonent: data.abonents[0].id,
            dataAbonent: dataManagement,
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    closePopupDeleteKeys () {
      this.popupImportDB = false;
      this.importFile = null;
    },
    async deleteCarNumber (actionShould, carNumber, notification) {
      await this.getAbonentData(carNumber);
      const date = [];
      await this.updateTableNumber(actionShould, carNumber, notification, date);
    },
    async updateTableNumber (actionShould, carNumber, notification, date, shouldFetchData) {
      const dataCar = {
        action_should: actionShould,
      };
      if (carNumber) {
        dataCar.car_number = carNumber;
      }
      if (notification) {
        dataCar.notify = notification ? 'on' : 'off';
      }
      if (date && date.length) {
        dataCar.start_date = date[0];
        dataCar.end_date = date[1];
      }
      await this.updateCarNumber({
        id: this.$route.params.id,
        data: dataCar,
      })
        .then((response) => {
          if (!shouldFetchData) {
            this.getData();
          }
          this.$flash_success('Дейсвие успешно сохранено!');

          if (response.data && response.data.invalid_entries) {
            // Обрабатываем невалидные записи когда делаем импорт
            response.data.invalid_entries.forEach(invalidEntry => {
              this.results.push({
                success: false,
                error: `Номер ${invalidEntry.car_number}: ${invalidEntry.error}`,
              });
            });
            this.resultDialog = true;
          }
          if (response.data.device_error) {
            this.$flash_danger(response.data.device_error);
          }
        })
        .catch((err) => {
          if (err.response.data.message) {
            this.$flash_warning(err.response.data.message);
          } else {
            this.$flash_warning('Ошибка при обновлении таблицы');
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 5px !important;
  font-size: 13px !important;
  max-width: 2%;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.border {
  border-radius: 16px;
}
.card-footer {
  background-color: #4C6C93;
  color: white;
  width: 65px !important;
  margin-right: 15px;
  height: 65px !important;
  padding: 5px 16px;
}
.routerLink {
  background: none;
  border: none;
  color: blue;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.routerLink:hover {
  color: darkblue;
  text-decoration: underline;
}

.v-application a {
  color: #434850;
}
.v-application p {
  margin-bottom: 0;
}

.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
}
</style>
